
import Vue from 'vue';
import { env } from '@/common/env';
import { bridge } from '@/common';

export default Vue.extend({
  beforeRouteEnter() {},
  props: {
    title: {
      type: String,
      default: '支付设置',
    },
  },
  data: () => {
    return {
      appName: env.appName,
      system: env.system,
    };
  },
  computed: {
    deviceType(): string {
      if (this.system === 'ios' && window.screen.height >= 812) {
        return 'iphoneX';
      } else if (this.system === 'ios' && window.screen.height < 812) {
        return 'iphoneNormal';
      } else {
        return 'android';
      }
    },
    titleStatusBarClass(): string {
      if (this.deviceType === 'iphoneX') {
        return this.isDianPing ? 'title-bar-ios-dp' : 'title-bar-ios-x';
      } else if (this.deviceType === 'iphoneNormal') {
        return 'title-bar-ios';
      }
      return 'title-bar-top';
    },
    customStyle(): { paddingTop: string } {
      let paddinStr = '0.88rem';
      if (this.deviceType === 'iphoneX') {
        paddinStr = '1.76rem';
      } else if (this.deviceType === 'iphoneNormal') {
        paddinStr = '1.28rem';
      }
      return {
        paddingTop: paddinStr,
      };
    },
    isDianPing(): boolean {
      return /dianping/i.test(this.appName)
    },
    headerImgStyle(): any {
      return {
        // backgroundImage: `url(${this.headerImg})`,
        // height: this.deviceType === 'android' ? '4.15rem' : '4.37rem',
        ...(this.deviceType === 'android' && {
          backgroundPosition: '0 -0.2rem',
        }),
        ...this.customStyle,
      };
    },
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initNav();
    })
  },
  methods: {
    initNav() {
      // 禁止ios回弹
      bridge.setBouncesUnabled();
      KNB.ready(() => {
        KNB.setNavigationBarHidden({
          flag: 1, // 0表示显示，1表示隐藏
          success: () => {
            // 点评APP标题栏背景会变成透明的，但标题栏上的元素需要手动设为空来隐藏，
            this.compatibleDP();
          },
          fail: () => {},
        });
      })
    },
    compatibleDP() {
      document.title = ''
      KNB.setLLButton({
        type: 'text',
        text: ' ',
        handle: () => {
          this.goBack();
        },
      });
    },
    goBack() {
      this.$emit('goBack');
    },
  },
});
